/* Grid
 * Grid線
 */
import * as THREE from "three";
import {Scene} from "./View3dScene";

export class Grid {

    private _lines: THREE.LineSegments;

    constructor() {
        const mat_groundline = new THREE.LineBasicMaterial({ color: 0x007700 })
        const offset = 0.01;
        const bufferGeometry: THREE.BufferGeometry = new THREE.BufferGeometry;
        const vertices = new Float32Array(21 * 6 * 2);
        let idx = 0;
        for (let i = -10; i <= 10; i++) {
            vertices[idx++] = i; vertices[idx++] = offset; vertices[idx++] = -10;
            vertices[idx++] = i; vertices[idx++] = offset; vertices[idx++] = 10;
        }
        for (let i = -10; i <= 10; i++) {
            vertices[idx++] = -10; vertices[idx++] = offset; vertices[idx++] = i;
            vertices[idx++] = 10; vertices[idx++] = offset; vertices[idx++] = i;
        }
        bufferGeometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
        this._lines = new THREE.LineSegments(bufferGeometry, mat_groundline);
        this._lines.name = "グリッド線";
    }

    public apply(scene: Scene): void {
        scene.me.add(this._lines);
    }

    public reset(scene: Scene): void {
        scene.me.remove(this._lines);
    }
}
